import {
    getMyOrder,
    getRowData,
    getActionColumn
} from './actions'

const getMyOrderData = (dispatch:Function) => (emailId:any) => {
    dispatch(getMyOrder(emailId))
}

const dispatchRowData = (dispatch:Function) => (data:any) => {
    dispatch(getRowData(data));
};
const dispatchActionColumn = (dispatch:Function) => (data:any) => {
dispatch(getActionColumn(data));
};
const operations = {
    getMyOrderData,
    dispatchRowData,
    dispatchActionColumn
}

export default operations